// extracted by mini-css-extract-plugin
export default {"layout":"style_layout__+ftkD","wrapper":"style_wrapper__WqGAO","header":"style_header__nX7a7"};